import { Link } from "@reach/router";
import React from "react";

import styled from "styled-components";
import { media } from "./Device";

import { SpockAnimation } from "./SpockAnimation";

const FooterWrapper = styled.div`
  background-color: #eee;
  margin-top: 105px;
  position: relative;

  ${media.tablet`
    margin-top: 95px;
  `}
`;

const Container = styled.div`
  max-width: 1200px;
  padding: 40px 20px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > * {
    width: 33.333%;
    max-width: 33.333%;
    flex-basis: 33.333%;
  }

  ${media.tablet`
    display: block;
    
    > * {
      flex-basis: 100%;
      max-width: 100%;
      width: 100%;;
    }
  `}
`;

const Social = styled.ul`
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0;

  li {
    margin: 0 10px 0 0;
    display: inline-block;

    &:hover,
    &:focus {
      a:before {
        color: #e1171e;
      }
    }
  }

  a {
    position: relative;

    &:last-child {
      margin: 0;
    }

    &:before {
      font-family: "Iconfont" !important;
      content: "\\e900";
      font-size: 24px;
      color: #999;
      transition: color 0.3s ease-in-out;
    }

    &.li {
      &:before {
        content: "\\e905";
      }
    }

    &.ig {
      &:before {
        content: "\\e904";
      }
    }

    &.fb {
      &:before {
        content: "\\e902";
      }
    }

    &.tw {
      &:before {
        content: "\\e906";
      }
    }
  }

  ${media.tablet`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    text-align: center;
    padding: 0;
    
    li {
      margin: 0 10px;
      
      &:last-child {
        margin: 0 10px;
        
        a:before {
          margin-top 0;
        }
      }
      
      &:hover,
      &:focus {
        a:before {
          color: #999;
        }
      }
    }
  `};
`;

const Copyright = styled.div`
  text-align: center;
  color: #999;
`;

const FooterNav = styled.ul`
  list-style: none;
  text-align: right;

  li {
    list-style: none;
    display: inline-block;
    margin-left: 30px;

    a {
      font-weight: 900;
      transition: color 0.3s ease-in-out;
      color: #999;
    }

    &:hover,
    &:focus {
      a {
        color: #e1171e;
      }
    }
  }

  ${media.tablet`
    text-align: center;
    padding: 0;
    
    li {
      margin: 0 10px !important;
      
      &:hover,
      &:focus {
        a {
          color: #999;
        }
      }
    }
  `}
`;

export class Footer extends React.Component {
  render() {
    let year = new Date().getFullYear();

    return (
      <FooterWrapper>
        <SpockAnimation />

        <Container>
          <Social>
            <li>
              {/* eslint-disable-next-line */}
              <a
                className={"icon li"}
                target={"_blank"}
                href={"https://www.linkedin.com/company/picnictechnologies/"}
              />
            </li>
            <li>
              {/* eslint-disable-next-line */}
              <a
                className={"icon ig"}
                target={"_blank"}
                href={"https://www.instagram.com/picnic/"}
              />
            </li>
            <li>
              {/* eslint-disable-next-line */}
              <a
                className={"icon fb"}
                target={"_blank"}
                href={"https://www.facebook.com/picnicNL"}
              />
            </li>
            <li>
              {/* eslint-disable-next-line */}
              <a
                className={"icon tw"}
                target={"_blank"}
                href={"https://www.twitter.com/picnic/"}
              />
            </li>
          </Social>

          <Copyright>&copy; {year} by Picnic. All rights reserved.</Copyright>

          <FooterNav>
            <li>
              <Link to={"/privacy"}>Privacy policy</Link>
            </li>
          </FooterNav>
        </Container>
      </FooterWrapper>
    );
  }
}
